import React from 'react';

const HomeFourSingleHowWorksItem = ({ icon, title,description, moveIcon}) => {
   return (
      <>
         <div className={`col-lg-3 col-md-3 ${moveIcon && 'pos-rel'}`}>
            <div className="howit-box text-center mb-40">
               <i><img src={`img/sicknote/how/icon-${icon}.png`} alt=""/></i>
               <h3>{title}</h3>
               <p>{description}</p>
               {/* {moveIcon && <img src="img/sicknote/how/move-icon.png" alt="" className={moveIcon ? 'move-icon' : '' }/>} */}
            </div>
         </div>
         {moveIcon &&
         <div className="col-lg-1 col-md-1 move-icon" style={{ marginTop: '100px' }}>
         <img src="img/sicknote/how/move-icon.png" alt="" className={moveIcon ? 'move-icon' : ''} />
         </div>
         }
      </>
   );
};

export default HomeFourSingleHowWorksItem;